<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Dissatisfied Filled" class="d-icon d-icon--dissatisfied-filled" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.438 6A5.437 5.437 0 1 0 .563 6a5.437 5.437 0 0 0 10.874 0Zm-3.5-1.5a.438.438 0 0 0-.438-.438h-.005a.437.437 0 1 0 0 .875H7.5a.437.437 0 0 0 .438-.437Zm-3 0a.438.438 0 0 0-.438-.438h-.005a.437.437 0 1 0 0 .875H4.5a.437.437 0 0 0 .438-.437Zm2.788 2.646A2.931 2.931 0 0 0 6 6.563a2.93 2.93 0 0 0-1.726.583 3.411 3.411 0 0 0-.608.571l-.01.013-.004.005-.001.001S3.65 7.739 4 8l-.35-.263a.437.437 0 0 0 .699.527m0 0 .003-.004a2.537 2.537 0 0 1 .437-.407A2.057 2.057 0 0 1 6 7.439c.504 0 .916.201 1.211.416a2.536 2.536 0 0 1 .437.406l.003.004v-.001.001a.438.438 0 0 0 .699-.526L8 8l.35-.263h-.001l-.001-.002-.004-.005-.01-.013a1.914 1.914 0 0 0-.155-.176 3.41 3.41 0 0 0-.453-.395M4.35 8.264v-.001m0 0Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconDissatisfiedFilled',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
